// src/component/Signup/index.jsx

import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  TextField,
  IconButton,
  OutlinedInput,
  InputAdornment,
  FormControl,
  Radio,
  RadioGroup,
  FormControlLabel,
  Select,
  MenuItem,
  Box,
  Snackbar,
  Alert,
  InputLabel,
} from "@mui/material";
import Person2Icon from "@mui/icons-material/Person2";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import TodayIcon from "@mui/icons-material/Today";
import image from "./google-icon.svg";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import Image from "../../asserts/signup1.png";
import { NavLink, useNavigate } from "react-router-dom";
import { axiosInstance } from "../Api/instance";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth } from "../../FirebaseConfig";
import { PrimaryButton } from "../ui/Buttons";
import { styled } from "@mui/material/styles";

const PageContainer = styled(Grid)(({ theme }) => ({
  minHeight: "100vh",
  backgroundColor: theme.palette.background.default,
  overflow: "hidden",
}));

const FormContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "48px 40px",
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.down("sm")]: {
    padding: "32px 20px",
  },
}));

const ImageContainer = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1F2937' : '#F8FAFC',
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "24px",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

const Signup = () => {
  const Navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConPassword, setShowConPassword] = useState(false);
  const [gender, setGender] = useState("");
  const [qualification, setQualification] = useState("");
  const [pass, setPass] = useState("");
  const [conpass, setconpass] = useState("");
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [number, setnumber] = useState("");
  const [date, setdate] = useState("");
  const [month, setmonth] = useState("");
  const [year, setyear] = useState("");
  const [loading, setLoading] = useState(false);


  // Snackbar Toast notification
  const [toast, setToast] = useState({ open: false, message: "", severity: "info" });

  const showToast = (message, severity = "info") => {
    setToast({ open: true, message, severity });
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowConPassword = () => setShowConPassword((show) => !show);

  useEffect(() => {
    localStorage.clear();
  }, []);

  const nameChange = (e) => {
    const value = e.target.value;
    const regex = /^[A-Za-z\s]*$/;
    if (regex.test(value)) {
      setname(value);
    }
  };

  const emailChange = (e) => {
    setemail(e.target.value);
  };

  const numberChange = (e) => {
    const value = e.target.value;
    const regex = /^[0-9\b]+$/;
    if (regex.test(value) && value.length <= 10) {
      setnumber(value);
    }
  };

  const dateChange = (e) => {
    setdate(e.target.value);
  };

  const monthChange = (e) => {
    setmonth(e.target.value);
  };

  const yearChange = (e) => {
    setyear(e.target.value);
  };

  const handleChange = (event) => {
    setPass(event.target.value);
  };

  const handleChangeConpass = (event) => {
    setconpass(event.target.value);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseDownConPassword = (event) => {
    event.preventDefault();
  };

  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };

  const handleQualificationChange = (event) => {
    setQualification(event.target.value);
  };

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const currentYear = new Date().getFullYear();
  const startYear = 1990;

  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, index) => currentYear - index
  );

  const handleClickOpen = async () => {
    if (!name || !email || !pass || !conpass || !number) {
      showToast("Please fill in all required fields", "warning");
      return;
    }
    if (number.length !== 10) {
      showToast("Please enter a valid 10-digit mobile number.", "warning");
      return;
    }
    
    setLoading(true);
    try {
      if (pass.length >= 6 && conpass.length >= 6) {
        if (pass === conpass) {
          await axiosInstance.post(
            `post/U_InsertStudent.php`,
            {
              username: name,
              email: email,
              password: pass,
              mobileno: number,
              dob: [year, month, date],
              gender: gender,
              qualification: qualification,
            }
          );
          showToast("Registration successful! Redirecting to login...", "success");
          setTimeout(() => Navigate("/signin"), 1500);
        } else {
          showToast("Passwords do not match", "error");
        }
      } else {
        showToast("Password must be at least 6 characters long", "warning");
      }
    } catch (error) {
      console.error("Error:", error);
      showToast("Enter Valid Credentials", "error");
    } finally {
      setLoading(false);
    }
  };

  const provider = new GoogleAuthProvider();

  const signInWithGoogle = async () => {
    setLoading(true);
    try {
      const result = await signInWithPopup(auth, provider);
      const signedInUser = result.user;

      localStorage.setItem("username", signedInUser.displayName);
      const username = localStorage.getItem("username");
      localStorage.setItem("userMail", signedInUser.email);
      localStorage.setItem("profile", signedInUser.photoURL);
      const userid = localStorage.getItem("userMail");

      let payload = {
        username: username,
        email: userid,
        mobileno: "",
        gender: "",
        qualification: "",
        password: "",
        dob: "",
      };
      
      await axiosInstance.post(
        `post/U_InsertStudent.php`,
        payload
      );
      showToast("Registration successful! Redirecting to login...", "success");
      setTimeout(() => Navigate("/signin"), 1500);
    } catch (error) {
      console.error("Google Sign-In Error", error);
      showToast("Google Authentication failed.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer container>
      <Snackbar 
        open={toast.open} 
        autoHideDuration={4000} 
        onClose={() => setToast(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert 
          onClose={() => setToast(prev => ({ ...prev, open: false }))} 
          severity={toast.severity} 
          sx={{ width: "100%", borderRadius: "12px", boxShadow: 3 }}
        >
          {toast.message}
        </Alert>
      </Snackbar>

      {/* Form Left Panel */}
      <FormContainer item xs={12} sm={6} style={{ overflowY: "auto", maxHeight: "100vh" }}>
        <Box style={{ maxWidth: "460px", width: "100%", margin: "0 auto", padding: "16px 0" }}>
          <Typography variant="h2" style={{ fontWeight: 800, color: "var(--color-primary)", marginBottom: "8px" }}>
            Create Account
          </Typography>
          <Typography variant="body1" color="textSecondary" style={{ marginBottom: "24px" }}>
            Join today to kickstart your nursing examination preparation.
          </Typography>

          <form onSubmit={(e) => { e.preventDefault(); handleClickOpen(); }}>
            
            {/* Full Name */}
            <Box style={{ marginBottom: "16px" }}>
              <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: "8px", display: "flex", alignItems: "center", gap: "6px" }}>
                Full Name
                <Person2Icon fontSize="inherit" color="action" />
              </Typography>
              <TextField
                fullWidth
                id="fullName"
                size="small"
                onChange={nameChange}
                value={name}
                required
                placeholder="Florence Nightingale"
                error={!/^[A-Za-z\s]*$/.test(name)}
              />
            </Box>

            {/* Email */}
            <Box style={{ marginBottom: "16px" }}>
              <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: "8px", display: "flex", alignItems: "center", gap: "6px" }}>
                Email Address
                <EmailIcon fontSize="inherit" color="action" />
              </Typography>
              <TextField
                fullWidth
                id="email"
                type="email"
                size="small"
                placeholder="florence@nursingupdate.in"
                onChange={emailChange}
                required
                value={email}
              />
            </Box>

            {/* Passwords */}
            <Grid container spacing={2} style={{ marginBottom: "16px" }}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: "8px", display: "flex", alignItems: "center", gap: "6px" }}>
                  Password
                  <LockIcon fontSize="inherit" color="action" />
                </Typography>
                <FormControl fullWidth variant="outlined" size="small">
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={showPassword ? "text" : "password"}
                    onChange={handleChange}
                    value={pass}
                    required
                    placeholder="••••••"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
                          {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: "8px", display: "flex", alignItems: "center", gap: "6px" }}>
                  Confirm Password
                  <LockIcon fontSize="inherit" color="action" />
                </Typography>
                <FormControl fullWidth variant="outlined" size="small">
                  <OutlinedInput
                    id="outlined-adornment-confirm-password"
                    type={showConPassword ? "text" : "password"}
                    onChange={handleChangeConpass}
                    value={conpass}
                    required
                    placeholder="••••••"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton onClick={handleClickShowConPassword} onMouseDown={handleMouseDownConPassword} edge="end">
                          {showConPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
            </Grid>

            {/* Mobile Number */}
            <Box style={{ marginBottom: "16px" }}>
              <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: "8px", display: "flex", alignItems: "center", gap: "6px" }}>
                Mobile Number
                <PhoneIphoneIcon fontSize="inherit" color="action" />
              </Typography>
              <TextField
                fullWidth
                id="mobileNumber"
                size="small"
                onChange={numberChange}
                value={number}
                required
                placeholder="10 digit number"
                error={number.length !== 10 && number.length > 0}
              />
            </Box>

            {/* Date of Birth */}
            <Box style={{ marginBottom: "16px" }}>
              <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: "8px", display: "flex", alignItems: "center", gap: "6px" }}>
                Date of Birth
                <TodayIcon fontSize="inherit" color="action" />
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="dob-date-label">Date</InputLabel>
                    <Select
                      labelId="dob-date-label"
                      id="dob-date"
                      value={date}
                      label="Date"
                      onChange={dateChange}
                    >
                      {Array.from({ length: 31 }, (_, idx) => (
                        <MenuItem key={idx + 1} value={idx + 1}>
                          {idx + 1}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="dob-month-label">Month</InputLabel>
                    <Select
                      labelId="dob-month-label"
                      id="dob-month"
                      value={month}
                      label="Month"
                      onChange={monthChange}
                    >
                      {months.map((name, idx) => (
                        <MenuItem key={idx + 1} value={idx + 1}>
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="dob-year-label">Year</InputLabel>
                    <Select
                      labelId="dob-year-label"
                      id="dob-year"
                      value={year}
                      label="Year"
                      onChange={yearChange}
                    >
                      {years.map((val) => (
                        <MenuItem key={val} value={val}>
                          {val}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>

            {/* Gender */}
            <Box style={{ marginBottom: "16px" }}>
              <Typography variant="subtitle2" style={{ fontWeight: 600, display: "flex", alignItems: "center", gap: "6px" }}>
                Gender
                <PersonSearchIcon fontSize="inherit" color="action" />
              </Typography>
              <RadioGroup
                row
                aria-label="gender"
                name="gender"
                value={gender}
                onChange={handleGenderChange}
              >
                <FormControlLabel value="male" control={<Radio size="small" />} label={<Typography variant="body1">Male</Typography>} />
                <FormControlLabel value="female" control={<Radio size="small" />} label={<Typography variant="body1">Female</Typography>} />
                <FormControlLabel value="other" control={<Radio size="small" />} label={<Typography variant="body1">Other</Typography>} />
              </RadioGroup>
            </Box>

            {/* Qualification */}
            <Box style={{ marginBottom: "24px" }}>
              <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: "8px", display: "flex", alignItems: "center", gap: "6px" }}>
                Qualification
                <AutoStoriesIcon fontSize="inherit" color="action" />
              </Typography>
              <FormControl fullWidth size="small">
                <Select
                  id="qualification"
                  value={qualification}
                  onChange={handleQualificationChange}
                  displayEmpty
                >
                  <MenuItem value="">Choose Your Qualification</MenuItem>
                  <MenuItem value="B.sc nursing ">B.sc nursing </MenuItem>
                  <MenuItem value="M.sc nursing ">M.sc nursing </MenuItem>
                  <MenuItem value="Others">Others</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <PrimaryButton
              type="submit"
              loading={loading}
              style={{ width: "100%", height: "46px", marginBottom: "16px" }}
            >
              Sign Up
            </PrimaryButton>
          </form>

          <Typography variant="body1" style={{ textAlign: "center", marginBottom: "16px", fontSize: "0.875rem" }}>
            Have an account?{" "}
            <NavLink to="/signin" style={{ textDecoration: "none", color: "var(--color-primary)", fontWeight: 700 }}>
              Sign In
            </NavLink>
          </Typography>

          <Box style={{ display: "flex", alignItems: "center", margin: "16px 0" }}>
            <Box style={{ flex: 1, height: "1px", backgroundColor: "var(--color-border)" }} />
            <Typography variant="caption" color="textSecondary" style={{ padding: "0 16px", fontWeight: 500 }}>
              OR
            </Typography>
            <Box style={{ flex: 1, height: "1px", backgroundColor: "var(--color-border)" }} />
          </Box>

          <PrimaryButton
            variant="outlined"
            onClick={signInWithGoogle}
            disabled={loading}
            style={{ 
              width: "100%", 
              height: "46px", 
              backgroundColor: "transparent",
              border: "1px solid var(--color-border)",
              color: "var(--color-text-primary)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <img
              src={image}
              alt=""
              style={{ width: "20px", height: "20px" }}
            />
            Continue with Google
          </PrimaryButton>
        </Box>
      </FormContainer>

      {/* Decorative Right Panel */}
      <ImageContainer item xs={12} sm={6}>
        <img
          src={Image}
          alt="Nursing Update Examination Prep"
          style={{
            width: "90%",
            maxHeight: "80vh",
            objectFit: "contain",
            borderRadius: "20px",
          }}
        />
      </ImageContainer>
    </PageContainer>
  );
};

export default Signup;
